import React from 'react';
import { render } from 'react-dom';
import { initialize } from 'react-ga';
import ErrorBoundary from '%app/js/common/components/ErrorBoundary';
import ensureTranslations from '%app/js/common/services/translationLoader';
import hasCookieCategoryConsent from '%paysera_service_agreement/js/CookiesUserAgreement/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS } from '%paysera_service_agreement/js/CookiesUserAgreement/config/constants';
import { GOOGLE_ANALYTICS_TRACKING_ID } from './config/constants';

import 'react-placeholder/lib/reactPlaceholder.css';

import Page from './component/Page';

if (hasCookieCategoryConsent(CATEGORY_STATISTICS)) {
    initialize(GOOGLE_ANALYTICS_TRACKING_ID);
}

ensureTranslations([
    'PayseraSeatSelectionIntegrationBundle',
    'PayseraServiceAgreementBundle',
]).then(() => {
    render(
        <ErrorBoundary>
            <Page />
        </ErrorBoundary>,
        document.getElementById('react-root'),
    );
});
